import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import { App } from "./app";
import "./main.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <SnackbarProvider domRoot={document.body}>
        <App />
      </SnackbarProvider>
    </BrowserRouter>
  </StrictMode>,
);
